import { render, staticRenderFns } from "./Pessoal.vue?vue&type=template&id=2da5afd2&scoped=true&"
import script from "./Pessoal.vue?vue&type=script&lang=js&"
export * from "./Pessoal.vue?vue&type=script&lang=js&"
import style0 from "./Pessoal.vue?vue&type=style&index=0&id=2da5afd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da5afd2",
  null
  
)

export default component.exports